<template>
    <div>
      <!--工具条-->
      <el-form :inline="true" :model="filters">
        <el-form-item style="margin-bottom: 10px" label="关键字">
          <el-input
            size="small"
            v-model="filters.search"
            placeholder="关键字"
          ></el-input>
        </el-form-item>
        <el-form-item style="margin-bottom: 10px">
          <el-button
            size="small"
            type="primary"
            icon="el-icon-search"
            @click="queryAll"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
      <!--列表-->
      <el-table
        size="mini"
        stripe
        border
        :data="tableData"
        highlight-current-row
        expand-on-click-node="false"
        style="width: 100%"
      >
        <el-table-column
          prop="Name"
          label="姓名"
          min-width="100"
        ></el-table-column>
        <el-table-column
          prop="Mobile"
          label="电话"
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="OrderCount"
          label="累计完成订单"
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="BalanceAmount"
          label="累计结算金额"
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="Bonos"
          label="累计好评金额"
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="OrderRegions"
          label="累计服务地区"
          min-width="200"
        ></el-table-column>
        <el-table-column
          prop="Desc"
          label="备注"
          min-width="100"
        ></el-table-column>
        <el-table-column prop="InsertTime" label="创建时间" width="130">
          <template slot-scope="scope">
            {{ format.dateTimeFormat(scope.row.InsertTime) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="handleDelete(scope.$index, scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-container">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="pageSizesList"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          :current-page.sync="pageIndex"
        ></el-pagination>
      </div>
    </div>
  </template>
  <script>
  import { getPageList, deleteObj } from "@/api/baseData/woker";
  export default {
    components: {
    },
    data() {
      return {
        filters: {
          search: "",
        },
        tableData: [],
        total: 0,
        pageIndex: 1,
        pageSize: 10,
        pageSizesList: [5, 10, 15, 20, 30, 50],
        dialogStatus: "",
        formVisible: false,
        dataForm: {},
      };
    },
    methods: {
      queryAll() {
        let para = {
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          search: this.filters.search,
        };
        getPageList(para).then((response) => {
          if (response) {
            this.tableData = response.Items;
            this.total = response.Total || response.Items.length;
          }
        });
      },
      //删除
      handleDelete: function (index, row) {
        this.$confirm("确认删除该记录吗?", "提示", {
          type: "warning",
        }).then(() => {
          let para = { key: row.Key };
          deleteObj(para).then((response) => {
            if (response) {
              this.msg.successMsg("操作成功");
              this.queryAll();
            }
          });
        });
      },
      handleSizeChange(val) {
        var pageSize = `${val}`;
        this.pageIndex = 1;
        this.pageSize = parseInt(pageSize);
        this.$nextTick(() => this.queryAll());
      },
      handleCurrentChange(val) {
        this.pageIndex = val;
        this.queryAll();
      },
    },
    mounted() {
      this.queryAll();
    },
  };
  </script>
  